import { Radio } from "./Radio";

export const SingleChoice = ({ label, checked, onChange, options, error, required }) => {
  return (
    <section className="single_choice-main">
      <label className="single_choice-label">
        {label}
        <span>{required ? "Required" : ""}</span>
      </label>
      {options.map(option => (
        <Radio text={option} checked={checked === option} onChange={onChange} key={option} />
      ))}
      <p className="single_choice-error">{error}</p>
    </section>
  );
};
